module.exports = __webpack_public_path__ + "static/media/groguru-long-logo@3x.8211663e.png";